import { call, put } from 'redux-saga/effects';
import { arrayToEntityMap } from "lib/data";

import { sendTeachersDataRequest } from "state/fetchSagas";
import { fetchMessagesSucceeded } from "state/teachers/actions";

import Message from "state/teachers/entities/Message";

export default function* fetchMessages(action) {
    
  const response = yield call(sendTeachersDataRequest, "get_my_messages");
  
  const messagesByID = arrayToEntityMap(Message.fromAppserverValueList, message => message.id, response.data);
  
  yield put( fetchMessagesSucceeded(messagesByID) );
  
}



// WEBPACK FOOTER //
// ./src/state/teachers/sagas/fetchMessages.js